import { render } from "./NoMessages.vue?vue&type=template&id=4b64516e&scoped=true"
import script from "./NoMessages.vue?vue&type=script&lang=js"
export * from "./NoMessages.vue?vue&type=script&lang=js"

import "./NoMessages.vue?vue&type=style&index=0&id=4b64516e&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b64516e"]])

export default __exports__